import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { DataService } from "src/app/services/Data.service";
import { DocumentsService } from "src/app/services/documents/documents.service";
import { NAVIGATIONS } from "src/app/shared/consts/navigations";
import Swal from "sweetalert2";
import {
  DOCUMENT_STATUS,
  DOCUMENT_STATUS_LABELS,
  DocumentsSPReponse,
} from "./components/document.model";
import { DocumentsAddModalComponent } from "./modals/documents-add-modal/documents-add-modal.component";
import { DocumentsEventsService } from "./service/documents-events.service";

@Component({
  selector: "app-documents",
  templateUrl: "documents.component.html",
  styleUrls: ["documents.component.css"],
})
export class DocumentsComponent implements OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  title = "Documents";
  editModalTitle = "Edit Document";
  documents: DocumentsSPReponse[] = [];
  SSuserId: Number;
  document: DocumentsSPReponse;
  modifiedDocuments: DocumentsSPReponse[] = [];
  @ViewChild('commentsModal') commentsModal: any;
  selectedCommentData: any = null;

  @ViewChild(DocumentsAddModalComponent) addModal: DocumentsAddModalComponent;

  readonly NAVIGATIONS = NAVIGATIONS;
  readonly DOCUMENT_STATUS_LABELS = DOCUMENT_STATUS_LABELS;

  isApprover = false;
  isUploader = false;
  isAdmin = false;

  columns = null;
  columnsToRender = null;

  pageSize = 50;

  showOnlyPending: boolean = false;

  private isSelectAllChanging = false;


  constructor(
    private documentService: DocumentsService,
    public dataService: DataService,
    private documentsEventsService: DocumentsEventsService
  ) { }

  ngOnInit() {
    this.documentsEventsService.refreshTable$.subscribe((result) => {
      this.refreshTable();
    });

    this.dataService.currentRolSource.pipe().subscribe((roles) => {
      this.isApprover = roles.some((x) => x == "APPROVER");
      this.isUploader = roles.some((x) => x == "UPLOADER");
      this.isAdmin = roles.some((x) => x == "CHATBOT_ADMIN");

      this.columns = [
        {
          data: null,
          title: `
      <div class="grid-checkbox">
        <input
          id="select-all-checkbox"
          type="checkbox"
        />
        <label for="select-all-checkbox" title="Select All"></label>
      </div>
    `,
          orderable: false,
          searchable: false,
          visible: this.isApprover,
          width: "5%",
          render: (data, type, row) => {
            if (
              row.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
              row.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
              row.status === DOCUMENT_STATUS.PENDING_UPLOAD
            ) {
              const checked = row.selected ? "checked" : "";
              return `
        <div class="grid-checkbox">
          <input
            id="check3-${row.id}"
            type="checkbox"
            class="needsclick doc-select"
            data-id="${row.id}"
            ${checked}
          />
          <label for="check3-${row.id}"></label>
        </div>
      `;
            }
            return "";
          },
        },
        { data: "fileName", title: "Name", visible: true, width: "25%" },
        {
          data: "status",
          title: "Status",
          visible: true,
          width: "15%",
          render: (data, type, row) => {
            return this.DOCUMENT_STATUS_LABELS?.[data] || data;
          },
        },
        {
          data: "active",
          title: "Active",
          visible: true,
          width: "10%",
          render: (data, type, row) => {
            const checked = data ? "checked" : "";
            const isDisabled =
              !this.isUploader || row.status !== DOCUMENT_STATUS.APPROVED;
            const disabled = isDisabled ? "disabled" : "";
            const switchDisabledClass = isDisabled
              ? "grid-switch-disabled"
              : "";
            return `
      <div class="switch-button ${switchDisabledClass}">
        <input
          type="checkbox"
          class="doc-active-switch"
          data-id="${row.id}"
          name="swt3-${row.id}"
          id="swt3-${row.id}"
          ${checked}
          ${disabled}
        />
        <span>
          <label for="swt3-${row.id}"></label>
        </span>
      </div>
    `;
          },
        },
        {
          data: "updatedByName",
          title: "Last Update User",
          visible: true,
          width: "15%",
        },
        {
          data: "lastUpdateDate",
          title: "Last Update Date",
          visible: true,
          width: "15%",
          render: (data) => {
            return data ? new Date(data).toLocaleString() : "-";
          },
        },
        {
          data: null,
          title: "Action",
          visible: true,
          orderable: false,
          searchable: false,
          width: "15%",
          render: (data, type, row) => {
            return `
          ${this.renderDeleteIcon(row.id, this.isAdmin)}
          <i class="icon s7-link grid-icons doc-link" data-url="${row.fileName
              }" title="View document" style="cursor:pointer"></i>
          <i class="icon s7-download grid-icons doc-download" data-url="${row.fileName
              }" title="Download document" style="cursor:pointer"></i>
          ${this.renderCommentIcon(row.id, row.comments && row.comments.length > 0)}
        `;
          },
        },
      ];

      this.columnsToRender = [
        { data: "select", title: "", visible: this.isApprover },
        { data: "fileName", title: "Name", visible: true },
        { data: "status", title: "Status", visible: true },
        { data: "active", title: "Active", visible: true },
        { data: "updatedByName", title: "Last Update User", visible: true },
        { data: "lastUpdateDate", title: "Last Update Date", visible: true },
        {
          data: "action",
          title: "Action",
          visible: true,
          orderable: false,
          searchable: false,
        },
      ];

      this.dtOptions = {
        pagingType: "simple_numbers",
        pageLength: this.pageSize,
        order: [],
        serverSide: true,
        processing: true,
        columns: this.columns,
        createdRow: (row: Node, data: DocumentsSPReponse) => {
          $(row).addClass("grid-data");

          if (
            data.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
            data.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
            data.status === DOCUMENT_STATUS.PENDING_UPLOAD
          ) {
            $(row).find(".switch-button").addClass("switch-pending");
          } else if (data.active) {
            $(row).find(".switch-button").addClass("switch-active");
          } else if (!data.active) {
            $(row).find(".switch-button").addClass("switch-not-active");
          }
        },
        ajax: (dataTablesParameters: any, callback) => {
          const draw = dataTablesParameters.draw;
          const start = dataTablesParameters.start;
          const length = dataTablesParameters.length;
          const searchValue = dataTablesParameters.search?.value || "";
          const sortColumn =
            dataTablesParameters.columns[dataTablesParameters.order[0]?.column]
              ?.data;
          const sortDirection = dataTablesParameters.order[0]?.dir;

          this.documentService
            .getDocuments(
              draw,
              start,
              length,
              searchValue,
              sortColumn,
              sortDirection,
              this.showOnlyPending,
              this.isApprover
            )
            .subscribe((response) => {
              this.documents = response.data.map((doc) => ({
                ...doc,
                originalActive: doc.active,
              }));

              callback({
                recordsTotal: response.totalCount,
                recordsFiltered: response.filteredCount,
                data: response.data,
              });
            });
        },
      };

      //skip to next js cycle to execute when
      //table is ready in DOM
      setTimeout(() => this.dtTrigger.next(), 0);
    });
  }

  renderDeleteIcon(id, render = false) {
    return render
      ? `<i class="icon s7-trash grid-icons doc-delete" data-id="${id}" title="Delete document" style="cursor:pointer"></i>`
      : "";
  }

  renderCommentIcon(id, render = false) {
    return render
      ? `<button type="button" class="icon-btn doc-comment" data-id="${id}" title="View comments" style="background:none;border:none;padding:0;cursor:pointer;">
         <i class="icon s7-comment grid-icons"></i>
       </button>`
      : "";
  }

  ngAfterViewInit() {
    $("#tableDocuments").on("change", ".doc-select", (event) => {
      const id = $(event.target).data("id");
      const checked = event.target.checked;
      const doc = this.documents.find((d) => d.id == id);
      if (doc) {
        doc.selected = checked;

        const $row = $(event.target).closest("tr");
        if (checked) {
          $row.addClass("grid-row-selected");
        } else {
          $row.removeClass("grid-row-selected");
        }

        if (!this.isSelectAllChanging) {
          const selectAll = document.getElementById("select-all-checkbox") as HTMLInputElement;
          if (selectAll) selectAll.checked = false;
        }
      }
    });

    $("#tableDocuments").on("change", "#select-all-checkbox", (event) => {
      const checked = event.target.checked;
      this.isSelectAllChanging = true;
      this.documents.forEach((doc) => {
        if (
          doc.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
          doc.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
          doc.status === DOCUMENT_STATUS.PENDING_UPLOAD
        ) {
          doc.selected = checked;
        }
      });
      $(".doc-select").prop("checked", checked).trigger("change");
      setTimeout(() => { this.isSelectAllChanging = false; }, 0);
    });

    $("#tableDocuments").on("change", ".doc-active-switch", (event: Event) => {
      const id = ($(event.target) as any).data("id");
      const doc = this.documents.find((d) => d.id == id);
      const checked = (event.target as HTMLInputElement).checked;
      if (doc) {
        this.onActiveChange(doc, event);

        const $row = $(event.target).closest("tr");

        const $switchButton = $($row).find(".switch-button");

        $switchButton
          .toggleClass(
            "switch-pending",
            doc.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
            doc.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
            doc.status === DOCUMENT_STATUS.PENDING_UPLOAD
          )
          .toggleClass(
            "switch-active",
            checked &&
            !(
              doc.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
              doc.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
              doc.status === DOCUMENT_STATUS.PENDING_UPLOAD
            )
          )
          .toggleClass(
            "switch-not-active",
            !checked &&
            !(
              doc.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
              doc.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
              doc.status === DOCUMENT_STATUS.PENDING_UPLOAD
            )
          );

        if (this.isRowModified(doc)) {
          $row.addClass("grid-row-modified");
        } else {
          $row.removeClass("grid-row-modified");
        }
      }
    });

    $("#tableDocuments").on("click", ".doc-delete", (event) => {
      const id = $(event.target).data("id");
      const doc = this.documents.find((d) => d.id == id);
      if (doc) {
        this.confirmDelete(doc);
      }
    });

    $("#tableDocuments").on("click", ".doc-link", (event) => {
      const documentName = $(event.target).data("url");
      this.openDocument(documentName);
    });

    $("#tableDocuments").on("click", ".doc-download", (event) => {
      const documentName = $(event.target).data("url");
      this.downloadDocument(documentName);
    });

    $(document).on("click", ".doc-comment, .swal-comment-icon", (event) => {
      const id =
        $(event.target).data("id") ||
        $(event.target).closest(".doc-comment, .swal-comment-icon").data("id");
      const doc = this.documents.find((d) => d.id == id);
      if (doc) {
        this.selectedCommentData = doc;
        this.commentsModal.open(doc);
      }
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  confirmDelete(document: DocumentsSPReponse) {
    this.document = document;

    Swal.fire({
      title: "Do you want to delete the document:",
      text: this.document.fileName,
      icon: "warning",
      confirmButtonColor: "#990000",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        this.delete(this.document.id);
      }
    });
  }

  delete(id: number) {
    this.documentService.deleteDocument(id).subscribe({
      next: (res) => {
        this.success("Document deleted successfully!");
        this.refreshTable(false);
      },
      error: () => {
        this.error("Error deleting document.");
      },
    });
  }

  success(message: string) {
    Swal.fire({
      title: message,
      icon: "info",
      confirmButtonColor: "#009",
      timer: 8000,
    });
  }

  error(message: string) {
    Swal.fire({
      title: message,
      icon: "error",
      confirmButtonColor: "#009",
      cancelButtonColor: "#aaa",
    });
  }

  refreshTable(reload = true): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(() => {
        const pageInfo = dtInstance.page.info();
        if (pageInfo.page > 0 && pageInfo.end === pageInfo.start) {
          dtInstance.page(pageInfo.page - 1).draw("page");
        }
      }, reload);
    });
  }

  openDocument(documentName: string) {
    this.documentService.downloadDocument(documentName).subscribe({
      next: (response) => {
        const url = this.getDownloadURL(response);

        const visualizableTypes = [
          "application/pdf",
          "image/png",
          "image/jpeg",
          "image/gif",
          "text/plain",
          "text/html",
        ];

        if (visualizableTypes.includes(response.data.contentType)) {
          window.open(url, "_blank");
        } else {
          this.downloadDocumentByURL(url, documentName);
        }
      },
      error: () => {
        this.error("Error opening file.");
      },
    });
  }

  downloadDocument(documentName: string) {
    if (!documentName) return;

    this.documentService.downloadDocument(documentName).subscribe({
      next: (response) => {
        const url = this.getDownloadURL(response);
        this.downloadDocumentByURL(url, documentName);
      },
      error: (error) => {
        this.error("Error downloading file.");
      },
    });
  }

  private getDownloadURL(response: any) {
    const byteCharacters = atob(response.data.raw);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: response.data.contentType });

    const url = window.URL.createObjectURL(blob);
    return url;
  }

  private downloadDocumentByURL(url: string, documentName: string) {
    const a = document.createElement("a");
    a.href = url;
    a.download = documentName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  openLink(url: string) {
    if (typeof window !== "undefined") {
      window.open(url, "_blank");
    }
  }

  onSelectChange(document: DocumentsSPReponse, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    document.selected = checked;
  }

  onActiveChange(document: DocumentsSPReponse, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    document.active = checked;
    const idx = this.modifiedDocuments.findIndex((d) => d.id === document.id);

    if (document.active === document.originalActive) {
      if (idx !== -1) {
        this.modifiedDocuments.splice(idx, 1);
      }
    } else {
      if (idx === -1) {
        this.modifiedDocuments.push({ ...document });
      } else {
        this.modifiedDocuments[idx].active = checked;
      }
    }
  }

  isRowModified(document: DocumentsSPReponse): boolean {
    return this.modifiedDocuments.some((d) => d.id === document.id);
  }

  confirmSubmitModifiedDocuments() {
    const changesText = this.modifiedDocuments
      .map((doc) => {
        const lastDot = doc.fileName.lastIndexOf(".");
        const name =
          lastDot !== -1 ? doc.fileName.slice(0, lastDot) : doc.fileName;
        const ext = lastDot !== -1 ? doc.fileName.slice(lastDot) : "";

        const displayName =
          name.length > 20
            ? `<span title="${doc.fileName}">${name.slice(
              0,
              20
            )}[...]${ext}</span>`
            : `<span title="${doc.fileName}">${name}${ext}</span>`;

        return `<div style="display:flex;align-items:center;gap:4px;padding: 4px 0 4px 0; border-bottom: 1px solid #babbba4D;">
          <div style="text-align:left; width: 45%;">${displayName}:</div> <b>${doc.active ? "Activate" : "Deactivate"}</b>
        </div>`;
      })
      .join("<br>");

    Swal.fire({
      title: "Do you want to submit the next document changes:",
      html: `
      ${changesText}
      <textarea id="swal-comments" class="swal2-textarea" maxlength="250" placeholder="Add comments (optional)" style="margin: 1rem 5px 5px 5px;display:block;width:calc(100% - 10px);resize:vertical;"></textarea>
      <div id="swal-char-count" style="text-align:right;margin-right:5px;font-size:12px;color:#888;">0/250</div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#009",
      confirmButtonText: "Proceed",
      preConfirm: () => {
        const comments = (document.getElementById('swal-comments') as HTMLTextAreaElement).value;
        if (comments && comments.length > 250) {
          Swal.showValidationMessage("Comments must be 250 characters or less");
          return false;
        }
        return comments;
      },
      didOpen: () => {
        const textarea = document.getElementById('swal-comments') as HTMLTextAreaElement;
        const counter = document.getElementById('swal-char-count');
        textarea.addEventListener('input', () => {
          counter.textContent = `${textarea.value.length}/250`;
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitModifiedDocuments(result.value || "");
      }
    });
  }

  submitModifiedDocuments(comments?: string) {
    if (this.modifiedDocuments.length === 0) return;
    this.documentService.submitChanges(this.modifiedDocuments, comments).subscribe({
      next: (res) => {
        this.success("Changes submitted successfully!");
        this.modifiedDocuments = [];
        this.refreshTable();
      },
      error: () => {
        this.error("Error submitting changes.");
      },
    });
  }

  submitApproveRejectDocuments(approve: boolean = true, comments?: string) {
    const selectedIds = this.documents
      .filter((doc) => doc.selected)
      .map((doc) => doc.id);

    if (selectedIds.length === 0) return;
    this.documentService
      .approveRejectDocuments(selectedIds, approve, comments)
      .subscribe({
        next: (res) => {
          this.success(
            `Documents ${approve ? "approved" : "rejected"} successfully!`
          );
          this.refreshTable();

          const selectAll = document.getElementById("select-all-checkbox") as HTMLInputElement;
          if (selectAll) selectAll.checked = false;
        },
        error: () => {
          this.error(`Error ${approve ? "approving" : "rejecting"}.`);
        },
      });
  }

  isDocumentPending(document: DocumentsSPReponse): boolean {
    return (
      document.status === DOCUMENT_STATUS.PENDING_ACTIVE ||
      document.status === DOCUMENT_STATUS.PENDING_INACTIVE ||
      document.status === DOCUMENT_STATUS.PENDING_UPLOAD
    );
  }

  isDocumentApproved(document: DocumentsSPReponse): boolean {
    return document.status === DOCUMENT_STATUS.APPROVED;
  }

  isDocumentRejected(document: DocumentsSPReponse): boolean {
    return document.status === DOCUMENT_STATUS.REJECTED;
  }

  confirmApproveRejectChanges(approve: boolean = true) {
    const actionText = approve ? "approve" : "reject";

    const changesText = this.documents
      .filter((doc) => doc.selected)
      .map((doc) => {
        const lastDot = doc.fileName.lastIndexOf(".");
        const name =
          lastDot !== -1 ? doc.fileName.slice(0, lastDot) : doc.fileName;
        const ext = lastDot !== -1 ? doc.fileName.slice(lastDot) : "";

        const displayName =
          name.length > 20
            ? `<span title="${doc.fileName}">${name.slice(
              0,
              20
            )}[...]${ext}</span>`
            : `<span title="${doc.fileName}">${name}${ext}</span>`;

        const hasComments = doc.comments && doc.comments.length > 0;
        const commentIcon = hasComments
          ? `<i class="icon s7-comment grid-icons swal-comment-icon"
        data-id="${doc.id}"
        style="color:#666;cursor:pointer;font-size: 16px;"
        title="View comments"></i>`
          : "";

        return `
        <div style="display:flex;align-items:center;gap:4px;padding: 4px 0 4px 0; border-bottom: 1px solid #babbba4D;">
          <div style="text-align:left; width: 45%;">${displayName}:</div> <b>${this.getChangeActionText(doc)}</b>
          ${commentIcon}
        </div>
      `;
      })
      .join("");

    Swal.fire({
      title: `Do you want to ${actionText} the next document changes:`,
      html: `
      ${changesText}
      <textarea id="swal-comments" class="swal2-textarea" maxlength="250" placeholder="Add comments (optional)" style="margin: 1rem 5px 5px 5px;display:block;width: calc(100% - 10px);resize: vertical;"></textarea>
      <div id="swal-char-count" style="text-align:right;margin-right:5px;font-size:12px;color:#888;">0/250</div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#009",
      confirmButtonText: "Proceed",
      preConfirm: () => {
        const comments = (document.getElementById('swal-comments') as HTMLTextAreaElement).value;
        if (comments && comments.length > 250) {
          Swal.showValidationMessage("Comments must be 250 characters or less");
          return false;
        }
        return comments;
      },
      didOpen: () => {
        const textarea = document.getElementById('swal-comments') as HTMLTextAreaElement;
        const counter = document.getElementById('swal-char-count');
        textarea.addEventListener('input', () => {
          counter.textContent = `${textarea.value.length}/250`;
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitApproveRejectDocuments(approve, result.value || "");
      }
    });
  }

  getChangeActionText(doc: DocumentsSPReponse): string {
    let actionText = "Change unkown";

    if (doc.status === DOCUMENT_STATUS.PENDING_ACTIVE) {
      actionText = "Activate document";
    } else if (doc.status === DOCUMENT_STATUS.PENDING_INACTIVE) {
      actionText = "Deactivate document";
    } else if (doc.status === DOCUMENT_STATUS.PENDING_UPLOAD) {
      actionText = "Upload document";
    }

    return actionText;
  }

  areDocumentsSelected(): boolean {
    return this.documents?.some((doc) => doc.selected);
  }

  clearFiles() {
    if (this.addModal) {
      this.addModal.clearFiles();
    }
  }

  synchronizeDocuments() {
    this.documentService.synchronizeDocuments().subscribe({
      next: (res) => {
        this.success("Documents synchronized successfully!");
        this.refreshTable();
      },
      error: () => {
        this.error("Error synchronizing documents.");
      },
    });
  }

  onPendingFilterChange() {
    this.refreshTable();
  }

  toggleSelectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.documents.forEach((doc) => {
      if (this.isDocumentPending(doc)) {
        doc.selected = checked;
      }
    });
  }

  areAllPendingSelected(): boolean {
    return this.documents
      .filter((doc) => this.isDocumentPending(doc))
      .every((doc) => doc.selected);
  }
}
